import { School } from '../school';
export class ReservationCancellationReason {
    constructor(
        public id?: number,
        public label?: string,
        public value?: number,
        public school?: School,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason.model.ts